import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { internalAuditAddUrl } from '@/utils/urls';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const title = t('internalAudits.create_title');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.InternalAuditEntity,
    parent: null,
    hrefRoot: internalAuditAddUrl(),
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-165) — flag-gated. The create surface has no
      // toolbar-hosted actions and the form owns its own Create/Cancel, so the
      // toolbar renders title-only.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.InternalAuditEntity}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
